import axios from "axios";

export const getInboundFeeds = (clientId) => {
  return axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/InboundFeeds/getFeeds/" + clientId)
    .then((res) => res.data);
};

export const addInboundFeed = (newFeed) => {
  return axios
    .post(import.meta.env.VITE_BACKEND_API + "/api/InboundFeeds/addFeed/", newFeed)
    .then((res) => res.data);
};

export const editInboundFeed = (editedFeed) =>{
  return axios
    .put(import.meta.env.VITE_BACKEND_API + "/api/InboundFeeds/editFeed/", editedFeed)
    .then((res) => res.data);
};

export const deleteInboundFeed = (feedId) =>{
  return axios
    .delete(import.meta.env.VITE_BACKEND_API + "/api/InboundFeeds/deleteFeed/" + feedId)
    .then((res) => res.data);
};